import React, { useState } from 'react';

import { getRouteApi } from '@tanstack/react-router';
import { Checkbox } from 'cpool-components/input/Checkbox';
import { TextArea } from 'cpool-components/input/TextArea';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaDemandedDocumentsKeys } from '~/features/leadDetails/schemas/demandedDocuments.schema';

type Props = {
    update: (path: SchemaDemandedDocumentsKeys, name: string, requested: boolean) => void;
};

const IndividualDocumentAppend: React.FC<Props> = ({ update }) => {
    const [text, setText] = useState('');
    const { t } = useTranslation();
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const disabled = !permissions.commands[AGGREGATE_NAMES.LOAN_REQUEST].demandDocuments;

    return (
        <div className="flex items-start gap-2" data-testid="individual-document-append">
            <div className="mt-2.5 shrink-0">
                <Checkbox
                    id="individual-document-append"
                    checked={false}
                    onChange={(e) => {
                        const name = text.replace(/\s+/g, ' ').trim();
                        if (e.target.checked && name) {
                            update('individualDocuments', name, true);
                            setText('');
                        }
                    }}
                    disabled={disabled}
                />
            </div>
            <TextArea
                className="grow"
                textareaClassName="border-grey-stroke"
                rows={5}
                aria-label={t('DOCUMENT_DEMANDER.INDIVIDUAL_DOCUMENT_PLACEHOLDER')}
                placeholder={t('DOCUMENT_DEMANDER.INDIVIDUAL_DOCUMENT_PLACEHOLDER')}
                value={text}
                onChange={(e) => setText(e.target.value)}
                disabled={disabled}
            />
        </div>
    );
};

export default IndividualDocumentAppend;
